module.exports = __webpack_public_path__ + "img/logo-studio.cfb647ee.png";